// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__tOKtb"};